import { AlertService } from '@/core/alert/services/alert.service';
import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';
import { TrackingService } from '@/core/tracking/services/tracking.service';
import { StorageService } from '@/core/storage/services/storage.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const alert = inject(AlertService);
  const _tracking = inject(TrackingService);
  const _storage = inject(StorageService);

  return next(req).pipe(
    catchError((res: HttpErrorResponse) => {
      const body = res.error;
      // const errorMessage = `
      //       HTTP Status Code: ${res.status},
      //       Mensaje: ${body.error.message || res.message || 'Sin mensaje'}
      //     `;
      const errorMessage = body.error.message || res.message || 'Sin mensaje';

      alert.open('error', '¡Ups! Algo salió mal', errorMessage);

      _tracking.track('error-api', {
        table_code: _storage.read('code'),
        establishment_uuid: _storage.read('uuid'),
        date_event: new Date().toString(),
        session_start: _storage.read('session_start'),
      });

      // return throwError(() => {
      //   errorMessage;
      // });
      // return throwError(
      //   () =>
      //     new HttpErrorResponse({
      //       error: 'your error',
      //       status: 403,
      //     }),
      // );
      // return EMPTY;
      return throwError(() => res);
    }),
  );
};
